import { render, staticRenderFns } from "./client-candidates.vue?vue&type=template&id=3012776c&scoped=true"
import script from "./client-candidates.vue?vue&type=script&lang=js"
export * from "./client-candidates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3012776c",
  null
  
)

export default component.exports